import http from "../../http-common";
export default class HubspotGetSubscriptions {
  getPreferenceSubscriptions(email: string) {
    let url = `/hubspot/subscriptions/${email}`;

    return http.get(url);
  }
}